<template>
  <div>
    <div v-if="showEdit">
      <v-card>
        <ApproveReceiptEdit
          v-if="!loading"
          :alldata="items"
          :readonly="!['admin', 'superadmin'].includes($store.state.privilege.role)"
          :editdata="editdata"
          @onsave="onsave"
          @close="showEdit = false"
        ></ApproveReceiptEdit>
      </v-card>
    </div>

    <div v-else>
      <div class="mb-3">
        <v-btn :loading="loading" color="grey" outline @click="handleShowExportList('exportxlsx')">
          <em class="fas fa-file-export" />
          &nbsp;
          {{ $t('export') }}&nbsp;
        </v-btn>
        <v-btn
          :loading="loading"
          color="grey"
          outline
          @click="handleShowExportList('exportxlsxReceipt')"
        >
          <em class="fas fa-file-export" />
          &nbsp;
          {{ $t('การตรวจใบเสร็จ') }}&nbsp;
        </v-btn>
        <v-btn
          :loading="loading"
          color="grey"
          outline
          @click="handleShowExportList('exportxlsxProducts')"
        >
          <em class="fas fa-file-export" />
          &nbsp;
          {{ $t('ข้อมูลการซื้อ') }}&nbsp;
        </v-btn>
      </div>

      <div class="mb-2">
        <date-filter
          v-model="selectedDate"
          :default-filter="'last_month'"
          @changeDate="onChangeDate"
        ></date-filter>
      </div>
      <v-layout row wrap class="pa-0 ma-0 mb-3">
        <v-flex xs4>
          <div>
            <v-btn outline @click="showsearch = true"><v-icon>search</v-icon>search</v-btn>
          </div>
        </v-flex>
        <v-flex xs8>
          <div class="text-xs-right">
            <span v-for="(item, k) in statusbuttons" :key="k">
              <v-btn v-if="item == status" depressed color="primary" style="border-radius: 4px">{{
                item
              }}</v-btn>
              <v-btn
                v-else
                color="grey"
                outline
                style="border-radius: 4px"
                @click="
                  status = item
                  onChangeDate()
                "
                >{{ item }}</v-btn
              >
            </span>
          </div>
        </v-flex>
      </v-layout>
      <v-layout row wrap class="ma-0 pa-0">
        <v-flex xs5>
          <div v-if="showCheckBox" style="display: flex">
            <div style="align-self: center" class="mr-3">
              <v-checkbox
                v-model="selectAll"
                color="primary"
                class="ma-0 pa-0"
                hide-details
                label="Select all"
              ></v-checkbox>
            </div>
            <div>
              <v-btn
                :loading="approveloading"
                :disabled="!selectedItems.length"
                depressed
                color="primary"
                @click="approveall"
                >Approve selected</v-btn
              >
            </div>
          </div>
        </v-flex>
      </v-layout>
      <pagination
        :key="timestamp"
        v-model="pageNumber"
        :limit="limit"
        :total="total"
        show-rows-per-page
        @onChange="handleChangePage"
      >
        <div>
          <div v-if="loading" class="text-xs-center">
            <scale-loader class="my-4" :loading="true" color="grey"></scale-loader>
          </div>
          <div v-else>
            <div v-if="total == 0">
              <div style="font-size: 22px" class="mt-4 grey--text text-xs-center">ไม่พบข้อมูล</div>
            </div>
            <div v-else>
              <v-card
                v-for="(item, k) in items"
                :key="k"
                class="pa-2 mb-3 pb-3"
                style="border-radius: 5px; border: 3px solid #1548a7; position: relative"
              >
                <v-checkbox
                  v-if="showCheckBox"
                  v-model="selectedItems"
                  style="position: absolute; left: 0px; top: 0px; margin-top: 0px"
                  color="primary"
                  :value="item.id"
                ></v-checkbox>
                <div v-if="item.status == 'reject'" class="red--text" style="font-size: 13px">
                  Rejected by Admin
                  <span
                    style="text-decoration: underline; cursor: pointer"
                    @click="showReason(item, true)"
                    >ดูสาเหตุ</span
                  >
                </div>
                <div v-if="getRejectedBy(item)" class="red--text" style="font-size: 13px">
                  Rejected by {{ getRejectedBy(item) }}
                  <span
                    style="text-decoration: underline; cursor: pointer"
                    @click="showReason(item)"
                    >ดูสาเหตุ</span
                  >
                </div>
                <div>
                  <v-layout row wrap class="pa-0 ma-0 px-4">
                    <v-flex xs5 class="pt-4" style="font-size: 16px; padding-top: 34px !important">
                      <template v-if="item.admin_status_option">
                        <div
                          class="pb-1"
                          v-html="handleFormatAdminStatusOption(item.admin_status_option)"
                        ></div>
                      </template>
                      <div><span>ชื่อลูกค้า : </span>{{ item.customer_name }}</div>
                      <div><span>เบอร์โทรศัพท์ : </span>{{ item.phone_number || '-' }}</div>
                      <div><span>ห้าง : </span>{{ item.department_store || '-' }}</div>
                      <div><span>สาขา : </span>{{ item.branch || '-' }}</div>
                      <div class="caption">
                        {{ item.timestamp | DateFormat('DD/MM/YYYY HH:mm') }}
                      </div>
                    </v-flex>
                    <v-flex xs4 style="padding-top: 60px !important">
                      <div><span>อาชีพ : </span>{{ item.job || '-' }}</div>
                      <div>เลขที่ใบเสร็จ : {{ item.ref_no ? item.ref_no : '-' }}</div>
                      <div>
                        คะแนนที่ได้ : {{ item.total_points === null ? '-' : item.total_points }}
                      </div>
                    </v-flex>
                    <v-flex xs3>
                      <div
                        style="display: flex; justify-content: flex-end; align-items: center"
                        class="text-xs-right pb-3"
                      >
                        <div class="mr-2" style="align-self: center">Admin</div>
                        <div>
                          <v-chip
                            class="px-2"
                            label
                            small
                            dark
                            :color="statusCustom(item.status).color"
                            >{{ statusCustom(item.status).text }}</v-chip
                          >
                        </div>
                        <div class="mx-2" style="align-self: center">Manager</div>
                        <div>
                          <v-chip
                            class="px-2"
                            label
                            small
                            dark
                            :color="statusCustom(item.manager_status).color"
                            >{{ statusCustom(item.manager_status).text }}</v-chip
                          >
                        </div>
                        <div class="mx-2" style="align-self: center">Accounting</div>
                        <div>
                          <v-chip
                            class="px-2"
                            label
                            small
                            dark
                            :color="statusCustom(item.accounting_status).color"
                            >{{ statusCustom(item.accounting_status).text }}</v-chip
                          >
                        </div>
                        <div
                          v-if="
                            $store.state.privilege && $store.state.privilege.role == 'superadmin'
                          "
                          class="pl-4"
                        >
                          <v-btn
                            outline
                            fab
                            color="primary"
                            small
                            class="ma-0"
                            @click="handleDeleteApproveReceipt(item)"
                          >
                            <v-icon>delete</v-icon>
                          </v-btn>
                        </div>
                      </div>
                      <v-layout row wrap>
                        <v-btn
                          class="px-5"
                          color="#3E70BD"
                          depressed
                          style="width: 100%; color: #fff"
                          @click="handleShowCustomerProfile(item)"
                        >
                          ข้อมูลลูกค้า
                        </v-btn>
                        <v-btn
                          :loading="activityLogLoading"
                          class="px-5"
                          color="#797979"
                          depressed
                          style="width: 100%; color: #fff"
                          @click="showAdminActivityLog(item)"
                        >
                          Activity Log
                        </v-btn>
                        <v-btn
                          style="width: 100%"
                          class="px-3"
                          color="primary"
                          depressed
                          @click="showAdminEdit(item)"
                        >
                          <span>{{ buttonTextEditData }}</span>
                        </v-btn>
                      </v-layout>
                    </v-flex>
                  </v-layout>
                </div>
              </v-card>
            </div>
          </div>
        </div>
      </pagination>
    </div>
    <v-dialog v-model="showActivityLog" max-width="800px" transition="dialog-transition">
      <v-card>
        <ActivityLog
          v-if="!loading && showActivityLog"
          :activity-log="activityLog"
          @close="showActivityLog = false"
        ></ActivityLog>
      </v-card>
    </v-dialog>

    <v-dialog
      v-model="showCustomerProfile"
      max-width="950px"
      persistent
      transition="dialog-transition"
    >
      <MemberInfoDialog
        v-if="customerProfileData"
        v-model="customerProfileData"
        @close="
          showCustomerProfile = false
          customerProfileData = null
        "
      ></MemberInfoDialog>
    </v-dialog>

    <v-dialog v-model="showsearch" width="500px" persistent>
      <v-card>
        <div style="float: right">
          <v-btn icon @click="showsearch = false"><v-icon>close</v-icon></v-btn>
        </div>
        <div class="pa-2 pt-4 pb-3">
          <div style="font-weight: 600; font-size: 20px"><v-icon>search</v-icon> ค้นหา</div>
          <div>
            <v-layout class="pa-0 ma-0" wrap row>
              <v-flex xs12 sm6 class="form-control pa-1">
                <label>{{ $t('ชื่อลูกค้า') }}</label>
                <input v-model="filter.customer_name" class="form-control" type="text" />
              </v-flex>
              <v-flex xs12 sm6 class="form-control pa-1">
                <label>{{ $t('เลขใบเสร็จ') }}</label>
                <input v-model="filter.ref_no" class="form-control" type="text" />
              </v-flex>
              <v-flex xs12 sm6 class="pa-1">
                <label>{{ $t('ห้าง') }}</label>
                <v-autocomplete
                  v-model="filter.department_store"
                  :items="departmentOptions"
                  placeholder="เลือกห้าง"
                  single-line
                  outline
                  hide-details
                  clearable
                  return-object
                />
              </v-flex>
              <v-flex xs12 sm6 class="pa-1">
                <label>{{ $t('สาขา') }}</label>
                <v-autocomplete
                  v-model="filter.branch"
                  :items="filteredBranchOptions"
                  placeholder="เลือกสาขา"
                  single-line
                  outline
                  hide-details
                  clearable
                  return-object
                />
              </v-flex>
            </v-layout>
          </div>
          <div class="text-xs-center">
            <v-btn outline color="grey" @click="clearsearch">Clear</v-btn>
            <v-btn color="primary" @click="onsearch">Search</v-btn>
          </div>
        </div>
      </v-card>
    </v-dialog>
    <div>
      <v-dialog v-model="showReasonDialog" persistent width="500px">
        <v-card v-if="showReasonDialog" class="px-5 pt-3 pb-3">
          <div class="text-xs-center" style="font-size: 18px; font-weight: bold; color: red">
            สาเหตุที่ Reject
          </div>
          <div class="mt-4" style="font-size: 16px">{{ currentreason }}</div>
          <div class="text-xs-center mt-3">
            <v-btn color="grey" outline @click="showReasonDialog = false">ปิด</v-btn>
          </div>
        </v-card>
      </v-dialog>
    </div>

    <template v-if="showExportList">
      <ExportList
        v-model="showExportList"
        :exportpagecount="exportpagecount"
        :exportlimit="exportlimit"
        :total="total"
        @handleExportByPage="handleExportByPage"
      />
    </template>
  </div>
</template>

<script>
import api from '@/api'
import { mapGetters } from 'vuex'
import ScaleLoader from 'vue-spinner/src/ScaleLoader.vue'
import * as XLSX from 'xlsx'
import ApproveReceiptEdit from './ApproveReceiptEdit.vue'
import DateFilter from '@/components/view/dashboard/DateFilter.vue'
import moment from 'moment'
import Pagination from '@/components/elements/Pagination2.vue'
import ExportList from './ExportList.vue'
import ActivityLog from './ActivityLog.vue'
import MemberInfoDialog from './MemberInfoDialog.vue'
import toaCrmApi from '@/api/toa-crm'

export default {
  components: {
    DateFilter,
    ApproveReceiptEdit,
    ScaleLoader,
    Pagination,
    ExportList,
    ActivityLog,
    MemberInfoDialog
  },
  data() {
    return {
      activityLogLoading: false,
      branchOptions: [],
      departmentOptions: [],
      selectedItems: [],
      currentreason: '',
      statusbuttons: ['all', 'pending', 'approved', 'reject'],
      selectedDate: {
        start: moment().subtract(7, 'days').format('YYYY-MM-DD'),
        end: moment().format('YYYY-MM-DD')
      },
      total: 0,
      offset: 0,
      limit: 10,
      pagetmp: 1,
      pageNumber: 1,
      importloading: false,
      showEdit: false,
      approveloading: false,
      editdata: '',

      columnName: '',
      items: [],
      status: 'all',
      filter: {
        ref_no: '',
        customer_name: '',
        department_store: undefined,
        branch: undefined
      },
      exportloading: false,
      showsearch: false,
      showReasonDialog: false,
      loading: true,

      timestamp: moment().format('x'),
      showExportList: false,
      currentExport: null, // exportxlsx , exportxlsxReceipt , exportxlsxProducts
      exportlimit: 10000,
      exportpagecount: 0,
      activityLog: null,
      showActivityLog: false,
      showCustomerProfile: false,
      customerProfileData: null
    }
  },
  computed: {
    purchase_amount() {
      if (this.$store.state.toacrmpointdata && this.$store.state.toacrmpointdata.purchase_amount) {
        return Math.floor(parseFloat(this.$store.state.toacrmpointdata.purchase_amount))
      } else return 0
    },
    exportDataReceipt() {
      return this.items.map((el) => {
        let sumprice = 0,
          points_by_purchase = 0,
          points_by_product = 0
        if (el.details && el.details.products) {
          sumprice = this.sumPrice(el.details.products)
          points_by_purchase = this.points_by_purchase(el.details.products)
          points_by_product = this.points_by_product(el.details.products)
        }

        const sumpoint = points_by_purchase + points_by_product
        return {
          เลขบัตรประชาชน: el.identity_number,
          ชื่อลูกค้า: el.first_name + '  ' + el.last_name,
          เบอร์โทรศัพท์: el.phone_number,
          วันที่อัพโหลดบิล: moment(el.timestamp).format('DD/MM/YYYY'),
          วันที่ซื้อในใบเสร็จ: el.details ? moment(el.details.date).format('DD/MM/YYYY') : '',
          เลขที่ใบเสร็จ: el.details && el.details.ref_no ? el.details.ref_no : el.ref_no,
          ยอดซื้อรวม: sumprice,
          คะแนนที่ได้: sumpoint,
          ห้าง: el.department_store,
          สาขา: el.branch,
          'ผู้ตรวจบิล (Admin)': el.admin,
          'วันที่ตรวจ (Admin)':
            el.verified_receipt_timestamp &&
            moment(el.verified_receipt_timestamp).format('DD/MM/YYYY'),
          'ผู้จัดการอนุมัติ (Manager)': el.manager,
          'วันที่ตรวจ (Manager)':
            el.manager_receipt_timestamp &&
            moment(el.manager_receipt_timestamp).format('DD/MM/YYYY'),
          'บัญชีผู้อนุมัติ (Accounting)': el.accounting,
          'วันที่ตรวจ (Accounting)':
            el.accounting_receipt_timestamp &&
            moment(el.accounting_receipt_timestamp).format('DD/MM/YYYY'),
          ที่อยู่รูปภาพใบเสร็จ: JSON.parse(el.ref_no_image).join(',')
        }
      })
    },
    showCheckBox() {
      return !['admin', 'superadmin'].includes(this.$store.state.privilege.role)
    },
    selectAll: {
      get: function () {
        if (this.items.length) {
          return this.items ? this.selectedItems.length == this.items.length : false
        } else return false
      },
      set: function (value) {
        var selected = []

        if (value) {
          this.items.forEach(function (item) {
            selected.push(item.id)
          })
        }

        this.selectedItems = selected
      }
    },
    filteredItems() {
      var result = [...this.items]
      const start = (this.pageNumber - 1) * this.limit
      const end = start + this.limit
      return result.slice(start, end)
      // return result
    },
    ...mapGetters(['selectedBot']),
    pagelength() {
      if (this.total) {
        return Math.ceil(this.total / this.limit)
      } else {
        return 1
      }
    },
    buttonTextEditData() {
      let text = ''
      if (this.$store.state.privilege) {
        switch (this.$store.state.privilege.role) {
          case 'superadmin':
            text = 'แก้ไขข้อมูล'
            break
          case 'admin':
            text = 'กรอกข้อมูล'
            break
          default:
            text = 'ดูข้อมูล'
            break
        }
      }
      return text
    },
    filteredBranchOptions() {
      if (!this.filter.department_store) {
        return this.branchOptions.reduce((acc, branch) => {
          if (!acc.some((b) => b.text === branch.text)) {
            acc.push(branch)
          }
          return acc
        }, [])
      }

      return this.branchOptions.filter(
        (branch) => branch.departmentStoreId === this.filter.department_store.value
      )
    }
  },
  async mounted() {
    this.loading = true
    Promise.all([this.getProduct(), this.getBranch(), this.getPointData()])
    await this.getData()
    this.loading = false
  },
  methods: {
    handleExportByPage(page) {
      switch (this.currentExport) {
        case 'exportxlsx':
          this.exportxlsx(page)
          break
        case 'exportxlsxReceipt':
          this.exportxlsxReceipt(page)
          break
        case 'exportxlsxProducts':
          this.exportxlsxProducts(page)
          break

        default:
          break
      }
      this.showExportList = false
    },
    handleShowExportList(type) {
      this.currentExport = type
      this.exportpagecount = Math.ceil(this.total / this.exportlimit)
      this.showExportList = true
    },
    async handleChangePage(val) {
      const { limit, offset, page } = val
      this.limit = limit
      this.offset = offset
      this.pageNumber = page
      this.timestamp = moment().format('x')
      await this.getData()
    },
    points_by_product(products) {
      var result
      result = products.reduce((acc, cur) => {
        return (
          acc + (cur.name ? parseFloat(cur.name.points || 0) : 0) * parseFloat(cur.quantity || 0)
        )
      }, 0)
      return Math.floor(result)
    },
    points_by_purchase(products) {
      var result = 0
      var sum = products.reduce((acc, cur) => {
        return acc + parseFloat(cur.price || 0) * parseFloat(cur.quantity || 0)
      }, 0)
      result = sum / this.purchase_amount
      return Math.floor(result)
    },
    sumPrice(products) {
      return Math.floor(
        parseFloat(
          products.reduce((acc, cur) => {
            return acc + parseFloat(cur.price || 0) * parseFloat(cur.quantity)
          }, 0)
        )
      )
    },
    getRejectedBy(item) {
      if (item.manager_remark || item.accounting_remark) {
        return item.manager_remark ? 'Manager' : 'Accounting'
      } else {
        return false
      }
    },
    async approveall() {
      this.$swal
        .fire({
          text: 'ยืนยันการ Approve ?',
          showCancelButton: true
        })
        .then(async (result) => {
          if (result.value) {
            this.approveloading = true
            if (this.$store.state.privilege.role == 'manager') {
              await this.managerSave()
            } else if (this.$store.state.privilege.role == 'accounting') {
              await this.accountingSave()
            }
            this.approveloading = false
            this.selectedItems = []
            await this.getData()
          }
        })
    },

    showReason(item, isAdmin = false) {
      if (isAdmin) {
        this.currentreason = item.remark
        this.showReasonDialog = true
      } else {
        this.currentreason = item.manager_remark || item.accounting_remark
        this.showReasonDialog = true
      }
    },
    onChangeDate() {
      try {
        this.offset = 0
        this.pageNumber = 1
        this.timestamp = moment().format('x')
        this.getData()
      } catch (error) {
        console.error(error)
      }
    },
    statusCustom(status) {
      if (status == 'none') {
        return { text: 'None', color: 'grey' }
      } else if (status == 'pending') {
        return { text: 'Pending', color: 'orange' }
      } else if (status == 'approved') {
        return { text: 'Approved', color: 'green' }
      } else if (status == 'reject') {
        return { text: 'Reject', color: 'red' }
      } else return { text: status, color: 'primary' }
    },
    getData() {
      return new Promise(() => {
        var data = {
          pageid: this.selectedBot.pageid, // required
          tab: this.$store.state.privilege.role, // required ** admin, manager, accounting **
          start_time: this.selectedDate.start
            ? moment(this.selectedDate.start).format('YYYY-MM-DD')
            : undefined, // YYYY-MM-DD
          end_time: this.selectedDate.end
            ? moment(this.selectedDate.end).format('YYYY-MM-DD')
            : undefined, // YYYY-MM-DD
          status: this.status, // all, pending, approved, reject
          limit: this.limit,
          offset: this.offset
        }
        for (const key in this.filter) {
          if (this.filter[key]) {
            if (['department_store', 'branch'].includes(key)) {
              Object.assign(data, { [key]: this.filter[key].text })
            } else {
              Object.assign(data, { [key]: this.filter[key] })
            }
          }
        }
        this.loading = true
        api.getapprovereceipttoacrm(data, (err, response) => {
          this.loading = false
          if (response.responsecode == 200) {
            this.items = response.data
            this.total = response.total
          }
        })
      })
    },
    getPointData() {
      return new Promise((resolve) => {
        var data = {
          pageid: this.selectedBot.pageid
        }
        api.getpointdatatoacrm(data, (err, response) => {
          if (response.responsecode == 200) {
            this.$store.state.toacrmpointdata = response.data[0]
          }
        })
        resolve()
      })
    },
    getBranch() {
      return new Promise((resolve) => {
        var data = {
          pageid: this.selectedBot.pageid
        }

        api.gettoacrmBranch(data, (err, response) => {
          const departmentOptions = response.data.reduce((acc, item) => {
            if (!acc.some((dept) => dept.id === item.department_store_id)) {
              acc.push({
                text: item.department_store,
                value: item.department_store_id
              })
            }
            return acc
          }, [])

          const branchOptions = response.data.reduce((acc, item) => {
            if (!acc.some((branch) => branch.id === item.branch_id)) {
              acc.push({
                text: item.branch,
                value: item.branch_id,
                departmentStoreId: item.department_store_id
              })
            }
            return acc
          }, [])
          this.branchOptions = branchOptions
          this.departmentOptions = departmentOptions
          this.$store.state.toacrmbranch = response.data

          resolve()
        })
      })
    },
    getProduct() {
      return new Promise((resolve) => {
        var data = {
          pageid: this.selectedBot.pageid
        }
        api.getproducttoacrm(data, (err, response) => {
          this.$store.state.toacrmproducts = response.data
          resolve()
        })
      })
    },

    clearsearch() {
      this.filter = {
        ref_no: '',
        customer_name: '',
        department_store: undefined,
        branch: undefined
      }
      try {
        this.offset = 0
        this.pageNumber = 1
        this.timestamp = moment().format('x')
        this.getData()
      } catch (error) {
        console.error(error)
      }
      this.showsearch = false
    },
    onsearch() {
      try {
        this.offset = 0
        this.pageNumber = 1
        this.timestamp = moment().format('x')
        this.getData()
      } catch (error) {
        console.error(error)
      }
      this.showsearch = false
    },
    async exportxlsx(page) {
      this.loading = true

      var data = {
        pageid: this.selectedBot.pageid, // required
        tab: this.$store.state.privilege.role, // required ** admin, manager, accounting **

        start_time: this.selectedDate.start
          ? moment(this.selectedDate.start).format('YYYY-MM-DD')
          : undefined, // YYYY-MM-DD
        end_time: this.selectedDate.end
          ? moment(this.selectedDate.end).format('YYYY-MM-DD')
          : undefined, // YYYY-MM-DD
        status: this.status,

        limit: this.exportlimit,
        offset: (page - 1) * this.exportlimit
      }
      this.loading = true
      api.getapprovereceipttoacrm(data, (err, response) => {
        this.loading = false
        if (response.responsecode == 200) {
          var exporteddata = response.data

          var json = exporteddata.map((val) => {
            var total_price = 0
            if (val.details) {
              total_price = val.details.products.reduce((a, b) => {
                return a + parseFloat(b.price) * parseInt(b.quantity)
              }, 0)
            }
            return {
              รหัสบัตรประชาชน: val.identity_number,
              ชื่อลูกค้า: val.customer_name,
              วันที่อัพโหลดบิล: moment(val.timestamp).format('DD/MM/YYYY HH:mm'),
              วันที่ซื้อในใบเสร็จ: val.details ? val.details.date : '',
              เลขที่ใบเสร็จ: val.details ? val.details.ref_no : '',
              ยอดซื้อรวม: total_price,
              คะแนนที่ได้: val.total_points
            }
          })

          const dataWS = XLSX.utils.json_to_sheet(json)
          const wb = XLSX.utils.book_new()
          XLSX.utils.book_append_sheet(wb, dataWS)
          XLSX.writeFile(wb, 'exportedReceiptData' + '.xlsx')
          this.loading = false
        }
      })
    },
    async exportxlsxReceipt(page) {
      this.loading = true
      var data = {
        pageid: this.selectedBot.pageid, // required
        tab: this.$store.state.privilege.role, // required ** admin, manager, accounting **

        start_time: this.selectedDate.start
          ? moment(this.selectedDate.start).format('YYYY-MM-DD')
          : undefined, // YYYY-MM-DD
        end_time: this.selectedDate.end
          ? moment(this.selectedDate.end).format('YYYY-MM-DD')
          : undefined, // YYYY-MM-DD
        status: this.status,

        limit: this.exportlimit,
        offset: (page - 1) * this.exportlimit
      }
      api.getapprovereceipttoacrm(data, (err, response) => {
        this.loading = false
        if (response.responsecode == 200) {
          var exporteddata = response.data
          var json = exporteddata.map((el) => {
            let sumprice = 0,
              points_by_purchase = 0,
              points_by_product = 0
            if (el.details && el.details.products) {
              sumprice = this.sumPrice(el.details.products)
              points_by_purchase = this.points_by_purchase(el.details.products)
              points_by_product = this.points_by_product(el.details.products)
            }

            const sumpoint = points_by_purchase + points_by_product
            // console.log(JSON.stringify(el.ref_no_image).join(','))
            return {
              เลขบัตรประชาชน: el.identity_number,
              ชื่อลูกค้า: el.first_name + '  ' + el.last_name,
              เบอร์โทรศัพท์: el.phone_number,
              วันที่อัพโหลดบิล: moment(el.timestamp).format('DD/MM/YYYY'),
              วันที่ซื้อในใบเสร็จ: el.details ? moment(el.details.date).format('DD/MM/YYYY') : '',
              เลขที่ใบเสร็จ: el.details && el.details.ref_no ? el.details.ref_no : el.ref_no,
              ยอดซื้อรวม: sumprice,
              คะแนนที่ได้: sumpoint,
              ห้าง: el.department_store,
              สาขา: el.branch,
              'ผู้ตรวจบิล (Admin)': el.admin,
              'วันที่ตรวจ (Admin)':
                el.verified_receipt_timestamp &&
                moment(el.verified_receipt_timestamp).format('DD/MM/YYYY'),
              'ผู้จัดการอนุมัติ (Manager)': el.manager,
              'วันที่ตรวจ (Manager)':
                el.manager_receipt_timestamp &&
                moment(el.manager_receipt_timestamp).format('DD/MM/YYYY'),
              'บัญชีผู้อนุมัติ (Accounting)': el.accounting,
              'วันที่ตรวจ (Accounting)':
                el.accounting_receipt_timestamp &&
                moment(el.accounting_receipt_timestamp).format('DD/MM/YYYY'),
              ที่อยู่รูปภาพใบเสร็จ: JSON.parse(el.ref_no_image).join(',')
            }
          })
          const dataWS = XLSX.utils.json_to_sheet(json)
          const wb = XLSX.utils.book_new()
          XLSX.utils.book_append_sheet(wb, dataWS)
          XLSX.writeFile(wb, 'exportedReceiptData' + '.xlsx')
          this.loading = false
        }
      })
    },
    async exportxlsxProducts(page) {
      this.loading = true
      var json = []

      var row = {
        start: 1,
        end: 0
      }

      var merge = []

      var data = {
        pageid: this.selectedBot.pageid, // required
        tab: this.$store.state.privilege.role, // required ** admin, manager, accounting **

        start_time: this.selectedDate.start
          ? moment(this.selectedDate.start).format('YYYY-MM-DD')
          : undefined, // YYYY-MM-DD
        end_time: this.selectedDate.end
          ? moment(this.selectedDate.end).format('YYYY-MM-DD')
          : undefined, // YYYY-MM-DD
        status: this.status,

        limit: this.exportlimit,
        offset: (page - 1) * this.exportlimit
      }
      api.getapprovereceipttoacrm(data, (err, response) => {
        this.loading = false
        if (response.responsecode == 200) {
          var exporteddata = response.data
          exporteddata.forEach((el, k) => {
            if (k) {
              row.start = row.end + 1
            }
            if (el.details && el.details.products.length) {
              row.end += el.details.products.length
              var points_by_product = this.points_by_product(el.details.products)
              el.details.products.forEach((product) => {
                json.push({
                  ชื่อลูกค้า: el.first_name + ' ' + el.last_name,
                  เบอร์โทรศัพท์: el.phone_number,
                  อาชีพ: el.job,
                  ห้าง: el.department_store,
                  สาขา: el.branch,
                  เลขที่ใบเสร็จ: el.details && el.details.ref_no ? el.details.ref_no : el.ref_no,
                  'Ref.': el.details ? el.details.ref : '',
                  วันที่ซื้อ: el.details ? moment(el.details.date).format('DD/MM/YYYY') : '',
                  SKU: product.name && product.name.sku ? product.name.sku : '',
                  รายการสินค้า:
                    product.name && product.name.product_name ? product.name.product_name : '',
                  ราคา: product.price,
                  จำนวน: product.quantity,
                  ราคารวม:
                    product.price && product.quantity
                      ? parseFloat(product.price) * parseFloat(product.quantity)
                      : 0,
                  'ผู้ตรวจ (Admin)': el.admin,
                  วันที่ตรวจ: el.verified_receipt_timestamp
                    ? moment(el.verified_receipt_timestamp).format('DD/MM/YYYY')
                    : '',
                  คะแนนที่ได้จากบิลนี้: points_by_product
                })
              })
            } else {
              row.end++
              json.push({
                ชื่อลูกค้า: el.first_name + ' ' + el.last_name,
                เบอร์โทรศัพท์: el.phone_number,
                อาชีพ: el.job,
                ห้าง: el.department_store,
                สาขา: el.branch,
                เลขที่ใบเสร็จ: el.details && el.details.ref_no ? el.details.ref_no : el.ref_no,
                'Ref.': el.details ? el.details.ref : '',
                วันที่ซื้อ: el.details ? moment(el.details.date).format('DD/MM/YYYY') : '',
                SKU: '',
                รายการสินค้า: '',
                ราคา: '',
                จำนวน: '',
                ราคารวม: '',
                'ผู้ตรวจ (Admin)': '',
                วันที่ตรวจ: '',
                คะแนนที่ได้จากบิลนี้: ''
              })
            }
            merge.push(
              { s: { r: row.start, c: 0 }, e: { r: row.end, c: 0 } }, //ชื่อลูกค้า
              { s: { r: row.start, c: 1 }, e: { r: row.end, c: 1 } }, //เบอร์โทรศัพท์
              { s: { r: row.start, c: 2 }, e: { r: row.end, c: 2 } }, //อาชีพ
              { s: { r: row.start, c: 3 }, e: { r: row.end, c: 3 } }, //ห้าง
              { s: { r: row.start, c: 4 }, e: { r: row.end, c: 4 } }, //สาขา
              { s: { r: row.start, c: 5 }, e: { r: row.end, c: 5 } }, //เลขที่ใบเสร็จ
              { s: { r: row.start, c: 6 }, e: { r: row.end, c: 6 } }, //Ref.
              { s: { r: row.start, c: 7 }, e: { r: row.end, c: 7 } } //วันที่ซื้อ
            )
          })
          const dataWS = XLSX.utils.json_to_sheet(json)

          dataWS['!merges'] = merge
          const wb = XLSX.utils.book_new()
          XLSX.utils.book_append_sheet(wb, dataWS)
          XLSX.writeFile(wb, 'exportedReceiptData' + '.xlsx')
          this.loading = false
        }
      })
    },
    managerSave() {
      return new Promise((resolve) => {
        var data = {
          pageid: this.selectedBot.pageid,
          rewardid_list: this.selectedItems,
          manager_status: 'approved' // approved หรือ reject
        }

        api.Managerapprovereceipttoacrm(data, async (err, response) => {
          if (response.responsecode == 200) {
            await this.$swal.fire({
              type: 'success',
              text: 'สำเร็จ'
            })
          }
          resolve()
        })
      })
    },
    accountingSave() {
      return new Promise((resolve) => {
        var data = {
          pageid: this.selectedBot.pageid,
          rewardid_list: this.selectedItems,
          accounting_status: 'approved' // approved หรือ reject
        }

        api.Accountingapprovereceipttoacrm(data, async (err, response) => {
          if (response.responsecode == 200) {
            await this.$swal.fire({
              type: 'success',
              text: 'สำเร็จ'
            })
          }
          resolve()
        })
      })
    },
    onImport(item) {
      this.importloading = true
      var data = {
        pageid: this.selectedBot.pageid,
        files: item[0]
      }
      api.toacrmimportbranch(data, async () => {
        this.importloading = false
        await this.$swal.fire({
          text: 'สำเร็จ',
          type: 'success'
        })
        this.getData()
      })
    },
    showAdminEdit(item) {
      this.editdata = item
      this.showEdit = true
    },
    async showAdminActivityLog(item) {
      try {
        this.activityLog = []
        this.activityLogLoading = true
        let activityLog = item
        if (activityLog.id) {
          const responseData = await toaCrmApi.getRewardPointLog(activityLog.pageid, activityLog.id)
          if (responseData.data && responseData.data.data) {
            this.activityLog = responseData.data.data
          }
        }
      } catch (error) {
        console.error(error)
      } finally {
        this.activityLogLoading = false
        this.showActivityLog = true
      }
    },
    onsave() {
      this.showEdit = false
      this.getData()
    },
    gotolink(link) {
      this.$nextTick(() => {
        window.location.href = link
      })
      // location.assign(this.qrlink)
    },
    showQrcode(item) {
      this.qrdialog = true
      this.qrdata = item
    },
    addBranch() {
      this.edittype = 'create'
      this.showEdit = true
    },
    handleFormatAdminStatusOption(status) {
      let color = '#000'
      if (status) {
        switch (status) {
          case 'รอลูกค้ายืนยันคะแนน/แนบบิลเพิ่ม':
            color = '#DCB900'
            break
          case 'ยกเลิกรายการ เนื่องจากไม่ทำรายการภายในเวลาที่กำหนด':
            color = '#FF0404'
            break

          case 'ลูกค้าแนบบิลเพิ่ม':
            color = '#34C931'
            break
          case 'ลูกค้ายืนยันคะแนน':
            color = '#34C931'
            break
          default:
            color = '#000'
            break
        }
      }
      return `<span style="color: ${color}">${status}</span>`
    },
    handleShowCustomerProfile(item) {
      this.customerProfileData = item
      this.showCustomerProfile = true
    },
    async handleDeleteApproveReceipt(item) {
      const vm = this
      try {
        const result = await vm.$swal.fire({
          type: 'warning',
          title: `คุณต้องการลบใบเสร็จ #${item.ref_no} ใช่หรือไม่ ?`,
          showCancelButton: true,
          confirmButtonText: this.$t('Confirm'),
          cancelButtonText: this.$t('cancel'),
          reverseButtons: true
        })

        if (result.value) {
          const response = await vm.deleteApproveReceipt(item.id)
          if (response && response.status === 200) {
            await vm.$swal.fire({
              type: 'success',
              text: `ลบใบเสร็จสำเร็จ`
            })
            vm.getData()
          }
        }
      } catch (error) {
        console.error(error)
      }
    },
    async deleteApproveReceipt(id) {
      const vm = this
      try {
        const pageId = vm.selectedBot.pageid
        const response = await toaCrmApi.deleteApproveRecript({
          config: {
            pageId,
            id
          }
        })

        if (response) {
          return response
        } else {
          return null
        }
      } catch (error) {
        console.error(error)
        return null
      }
    }
  }
}
</script>

<style lang="scss">
@import 'photoviewer/dist/photoviewer.css';
</style>



// WEBPACK FOOTER //
// src/components/view/template/toacrm/ApproveReceipt.vue